const LANGUAGE_LABELS = {
  javascript: 'JavaScript',
  bash: 'bash',
  css: 'css',
};

export default LANGUAGE_LABELS;
